import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Contrast.svg",
  "use": "Contrast.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Contrast.svg\"><path d=\"M32.0065,56.0138a24,24,0,1,1,24-24A24,24,0,0,1,32.0065,56.0138ZM46.8908,45.4382A20.03,20.03,0,0,0,18.6035,17.1508a.9972.9972,0,0,0-.0177,1.4386L45.4523,45.4559A.9972.9972,0,0,0,46.8908,45.4382Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol